import { GET, POST, PUT } from '../request'

export const getAsignaturas = () =>
  GET('/api/core/planificacion/asignatura/list')

export const createAsignatura = asignatura =>
  POST('/api/core/planificacion/asignatura', asignatura)

export const updateAsignatura = ({
  id,
  nombre,
  nombre_completo,
  descripcion,
  tipo,
  nivel,
  subnivel,
  activa
}) => {
  return PUT('/api/core/planificacion/asignatura', {
    id,
    nombre,
    nombre_completo,
    descripcion,
    tipo,
    nivel,
    subnivel,
    activa
  })
}
